import { Book, Character } from '@monorepo/shared/src/graph/schema-generated-types-student';

export enum ActivityActionTypes {
  SET_ACTIVITY = 'SET_ACTIVITY',
  SET_SHOW_AFFIRMATION = 'SET_SHOW_AFFIRMATION',
}

export type ActivityActions =
  | { type: ActivityActionTypes.SET_ACTIVITY; payload: ActivityState['activity'] }
  | { type: ActivityActionTypes.SET_SHOW_AFFIRMATION; payload: boolean };

export type ActivityState = {
  showAffirmation: boolean;
  activity: {
    book: Book | null;
    characters: Array<Character> | [];
    title: string;
    description: string;
    type: string;
    url: string;
  };
};

export type UseActivity = [ActivityState, null];
